import React from 'react';
import { CaptionText, HeadingText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

const GNCSubheader = ({ organizationName, purpose }) => {
  return (
    <div className="donate_sub_header donate-main-content">
      <div className="gnc-subheader">
        <HeadingText className="charity-header" size="lg">
          {purpose}
        </HeadingText>
        <CaptionText>
          {getContent('locals')(
            'common/subHeader'
          )('label.supportingOrganization', { organization: organizationName })}
        </CaptionText>
      </div>
    </div>
  );
};

GNCSubheader.propTypes = {
  organizationName: PropTypes.string,
  purpose: PropTypes.string,
};

export default GNCSubheader;
